import * as React from 'react';

import {CategoryResultCard} from './CategoryResultCard';
import {SearchResult, SubCat} from '../search.types';
import {URLBuilder} from '../../../server/tools/url-builder/url-builder.class';
import {User} from '../../users/user.class';

interface CategoryResultProps {
    buildURL: URLBuilder;
    debugWebcat: boolean;
    resultList: SearchResult;
    subCat: SubCat;
    user: User;
}

export const CategoryResult = ({buildURL, debugWebcat, resultList, subCat, user}: CategoryResultProps) => (
    <div className="tw-w-full md:tw-w-1/3 xl:tw-w-1/4 tw-mb-4 tw-pr-0 md:tw-pr-4">
        <CategoryResultCard
            buildURL={buildURL}
            debugWebcat={debugWebcat}
            resultList={resultList}
            subCat={subCat}
            user={user}
        />
    </div>
);
